import { IIndexable, t_key } from 'core-ts-types';

export type DB<T> = Record<string, T>;

export const getElement = <T>(db: DB<T>, k: t_key | IIndexable): T | undefined => {
  return k.hasOwnProperty('id') ? db[k['id'] as t_key] : !!db[k as t_key] ? db[k as t_key] : undefined;
};

export const safeCompact = <T>(v: (T | undefined)[]): T[] => {
  return v as T[];
};



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-orm/src/core/db_utilities.ts